@switch (part) {
	@case ("nav") {
		<span class="aa-mat-icon">chevron_right</span>
		<button
			type="button"
			(click)="selectStep.emit(3)"
			[class.completed]="selectedIndex > 3"
			[class.active]="selectedIndex === 3"
			[disabled]="selectedIndex < 3"
		>
			Final Rating &amp; Signoff
		</button>
	}
	@case ("review") {
		<div class="relative px-6 pt-[52px]">
			<p class="mb-6 text-base text-violet">
				Review the assessment summary before sending to the candidate for sign-off.
			</p>
			<button type="button" class="aa-btn !bg-violet" data-size="small" data-variant="primary" (click)="preview.emit()">
				Preview Summary
			</button>
		</div>

		<div class="rating-form-step-actions flex flex-row justify-between gap-4 px-6">
			<button type="button" data-variant="tertiary" class="aa-btn" (click)="back.emit()">Back</button>
			<div class="flex-1"></div>
			<button type="button" data-variant="primary" class="step-submit aa-btn" (click)="nextStep.emit()">
				Sign off
			</button>
		</div>
	}
	@case ("send") {
		<button
			type="button"
			class="step-submit aa-btn"
			data-variant="primary"
			(click)="send.emit()"
			[disabled]="!canSend || sending"
		>
			{{ sending ? "Sending…" : "Send to Candidate" }}
		</button>
	}
	@case ("overlay") {
		@if (sending) {
			<div
				class="fixed inset-0 z-50 flex items-center justify-center bg-black/30"
				role="status"
				aria-live="polite"
				aria-busy="true"
			>
				<div class="rounded bg-white px-8 py-6 text-center shadow-lg">
					<p class="font-semibold text-violet">Sending to candidate…</p>
					<p class="mt-2 text-sm text-gray-600">Please wait while the assessment is prepared.</p>
				</div>
			</div>
		}
	}
}
